//TODO - move providers inside this view
//TODO - move pending transactions to accounting tab

import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import PersonIcon from "@material-ui/icons/Person";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import MarketingPlan from "views/Components/MarketingPlan";
import MarketingPlanDisplay from "views/Components/MarketingPlanDisplay";
import FeeCalculator from "views/Components/FeeCalculator";
import BatchMessage from "views/Components/BatchMessage";
import BatchMessageList from "views/Components/BatchMessageList";
import CustomMemberships from "views/Components/CustomMemberships";
import WebSiteWidget from "views/Components/WebSiteWidget";
import Assessment from "views/Pages/Assessment";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";

import axios from 'axios';
import { API_ROOT, MARKETING_PLAN_TEMPLATE_CODE } from 'api-config';
import { getApiHeaders } from '../../assets/helpers/apiHelper.jsx';

const style = {
  dialogPaper: {
    minHeight: '60vh',
    maxHeight: '80vh',
  },
  ...userProfileStyles
};

class Tools extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      userId: sessionStorage.getItem('userId'),
      practiceAssessmentDialogueOpen: false,
      marketingDialogueOpen: false,
      marketingDisplayDialogueOpen: false,
      feeCalculatorDialogueOpen: false,
      customMembershipsDialogueOpen: false,
      batchMessageDialogueOpen: false,
      batchMessageListDialogueOpen: false,
      webSiteWidgetDialogueOpen: false,
      marketingTemplateId: '',
      marketingTemplateCompleted: false
    };
  }


  componentDidMount(){
    this._isMounted = true;
    this.getMarketingTemplateId()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.marketingTemplateId !== prevState.marketingTemplateId) {
      this.checkForCompletedTemplate()
    }
  }

  getMarketingTemplateId() {
    axios.get(`${API_ROOT}/marketing/templateMeta/?templateCode=`+MARKETING_PLAN_TEMPLATE_CODE, {headers: getApiHeaders()})
      .then(res => this.setMarketingTemplateId(res.data));
  }

  setMarketingTemplateId(res) {
    if (this._isMounted) {
      if (res.id) {
        this.setState({
          marketingTemplateId: res.id
        });
      }
    }
  }

  checkForCompletedTemplate() {
    axios.get(`${API_ROOT}/marketing/templateAnswers/?templateId=`+this.state.marketingTemplateId+`&userId=`+this.state.userId, {headers: getApiHeaders()})
      .then(res => this.setCompletedTemplate(res.data));
  }

  setCompletedTemplate(res) {
    if (this._isMounted) {
      if (!res.message) {
        this.setState({
          marketingTemplateCompleted: true
        });
      }
    }
  }

  handlePracticeAssessmentDialogOpen() {
    this.setState({
      practiceAssessmentDialogueOpen: true
    });
  };

  handlePracticeAssessmentDialogClose() {
    this.setState({
      practiceAssessmentDialogueOpen: false
    });
  };

  handleMarketingPlanDialogOpen() {
    this.setState({
      marketingDialogueOpen: true,
      marketingDisplayDialogueOpen: false
    });
  };

  handleMarketingPlanDialogClose() {
    this.setState({
      marketingDialogueOpen: false
    });
  };

  handleMarketingPlanDisplayDialogOpen() {
    this.setState({
      marketingDisplayDialogueOpen: true,
      marketingDialogueOpen: false
    });
  };

  handleMarketingPlanDisplayDialogClose() {
    this.setState({
      marketingDisplayDialogueOpen: false
    });
  };

  handleFeeCalculatorDialogOpen() {
    this.setState({
      feeCalculatorDialogueOpen: true
    });
  };

  handleFeeCalculatorDialogClose() {
    this.setState({
      feeCalculatorDialogueOpen: false
    });
  };

  handleCustomMembershipsDialogOpen() {
    this.setState({
      customMembershipsDialogueOpen: true
    });
  };

  handleCustomMembershipsDialogClose() {
    this.setState({
      customMembershipsDialogueOpen: false
    });
  };

  handleBatchMessageDialogOpen() {
    this.setState({
      batchMessageDialogueOpen: true
    });
  };

  handleBatchMessageDialogClose() {
    this.setState({
      batchMessageDialogueOpen: false
    });
  };

  handleBatchMessageListDialogOpen() {
    this.setState({
      batchMessageListDialogueOpen: true,
      batchMessageDialogueOpen: false
    });
  };

  handleBatchMessageListDialogClose() {
    this.setState({
      batchMessageListDialogueOpen: false
    });
  };

  handleWebSiteWidgetDialogueOpen() {
    this.setState({
      webSiteWidgetDialogueOpen: true
    });
  };

  handleWebSiteWidgetDialogueClose() {
    this.setState({
      webSiteWidgetDialogueOpen: false
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Dialog
          classes={{ paper: classes.dialogPaper }}
          open={this.state.practiceAssessmentDialogueOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
          fullWidth={true}
        >
          <DialogTitle id="form-dialog-title">Practice assessment</DialogTitle>
          <DialogContent>
            <Assessment/>
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handlePracticeAssessmentDialogClose.bind(this)} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          classes={{ paper: classes.dialogPaper }}
          open={this.state.marketingDialogueOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
          fullWidth={true}
        >
          <DialogTitle id="form-dialog-title">Marketing plan</DialogTitle>
          <DialogContent>
            <MarketingPlan
            displayPlanOpen={this.handleMarketingPlanDisplayDialogOpen.bind(this)}
            templateId = {this.state.marketingTemplateId}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleMarketingPlanDialogClose.bind(this)} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          classes={{ paper: classes.dialogPaper }}
          open={this.state.marketingDisplayDialogueOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
          fullWidth={true}
        >
          <DialogTitle id="form-dialog-title">Marketing plan</DialogTitle>
          <DialogContent>
            <MarketingPlanDisplay
              templateId = {this.state.marketingTemplateId}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleMarketingPlanDialogOpen.bind(this)} color="cirrusBlue">
              Back
            </Button>
            <Button onClick={this.handleMarketingPlanDisplayDialogClose.bind(this)} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          classes={{ paper: classes.dialogPaper }}
          open={this.state.feeCalculatorDialogueOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
          fullWidth={true}
        >
          <DialogTitle id="form-dialog-title">Subscription fee calculator</DialogTitle>
          <DialogContent>
            <FeeCalculator

            />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleFeeCalculatorDialogClose.bind(this)} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          classes={{ paper: classes.dialogPaper }}
          open={this.state.customMembershipsDialogueOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
          fullWidth={true}
        >
          <DialogTitle id="form-dialog-title">Custom memberships</DialogTitle>
          <DialogContent>
            <CustomMemberships

            />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleCustomMembershipsDialogClose.bind(this)} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          classes={{ paper: classes.dialogPaper }}
          open={this.state.batchMessageDialogueOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
          fullWidth={true}
        >
          <DialogTitle id="form-dialog-title">Batch email/text</DialogTitle>
          <DialogContent>
            <BatchMessage

            />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleBatchMessageDialogClose.bind(this)} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          classes={{ paper: classes.dialogPaper }}
          open={this.state.batchMessageListDialogueOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
          fullWidth={true}
        >
          <DialogTitle id="form-dialog-title">Batch emails/texts sent</DialogTitle>
          <DialogContent>
            <BatchMessageList

            />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleBatchMessageListDialogClose.bind(this)} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          classes={{ paper: classes.dialogPaper }}
          open={this.state.webSiteWidgetDialogueOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
          fullWidth={true}
        >
          <DialogTitle id="form-dialog-title">Web site widget</DialogTitle>
          <DialogContent>
            <WebSiteWidget />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleWebSiteWidgetDialogueClose.bind(this)} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Card>
          <CardHeader color="cirrusBlue" icon>
            <CardIcon color="cirrusBlue">
              <PersonIcon />
            </CardIcon>
            <h4 id="organizationProvidersHeader" className={classes.cardIconTitle}>
              Tools
            </h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <Button
                  round
                  onClick={this.handlePracticeAssessmentDialogOpen.bind(this)}
                  color="cirrusBlue"
                  disabled={this.state.inputDisabled}
                  id="openPracticeAssessmentButton"
                >
                  practice assessment
                </Button>
                <span style={{paddingLeft: '20px'}}>Enter and update practice financial information to model effects of your membership plan
                </span>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <Button
                  round
                  onClick={this.handleMarketingPlanDialogOpen.bind(this)}
                  color="cirrusBlue"
                  disabled={this.state.inputDisabled}
                  id="openMarketingPlanButton"
                >
                  marketing plan
                </Button>
                <span style={{paddingLeft: '20px'}}>Develop a marketing plan for your office

                  <span>
                    <Button
                      round
                      onClick={this.handleMarketingPlanDisplayDialogOpen.bind(this)}
                      color="transparent"
                      disabled={this.state.inputDisabled}
                      id="viewMarketingPlanButton"
                      size="sm"
                      style={this.state.marketingTemplateCompleted ? {} : { display: 'none' }}
                    >
                      &mdash; view current plan
                    </Button>


                  </span>
                </span>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <Button
                  round
                  onClick={this.handleFeeCalculatorDialogOpen.bind(this)}
                  color="cirrusBlue"
                  disabled={this.state.inputDisabled}
                  id="openFeeCalculatorButton"
                >
                  fee calculator
                </Button>
                <span style={{paddingLeft: '20px'}}>Calculate the appropriate subscription fee for your office
                </span>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <Button
                  round
                  onClick={this.handleCustomMembershipsDialogOpen.bind(this)}
                  color="cirrusBlue"
                  disabled={this.state.inputDisabled}
                  id="openCustomMembershipsButton"
                >
                  custom memberships
                </Button>
                <span style={{paddingLeft: '20px'}}>Add, edit and remove custom memberships for your practice
                </span>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <Button
                  round
                  onClick={this.handleWebSiteWidgetDialogueOpen.bind(this)}
                  color="cirrusBlue"
                  disabled={this.state.inputDisabled}
                  id="openCustomMembershipsButton"
                >
                  web site widget
                </Button>
                <span style={{paddingLeft: '20px'}}>Get an html snippet to add a signup widget to your web site
                </span>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <Button
                  round
                  onClick={this.handleBatchMessageDialogOpen.bind(this)}
                  color="cirrusBlue"
                  disabled={this.state.inputDisabled}
                  id="openBatchMessageButton"
                >
                  batch email/text
                </Button>
                <span style={{paddingLeft: '20px'}}>Send emails or texts to your patients regarding your membership program
                  <span>
                    <Button
                      round
                      onClick={this.handleBatchMessageListDialogOpen.bind(this)}
                      color="transparent"
                      disabled={this.state.inputDisabled}
                      id="viewBatchMessageListButton"
                      size="sm"
                    >
                      &mdash; view past messages
                    </Button>


                  </span>
                </span>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </div>
    )

  }


}

export default withStyles(style)(Tools);